import { HttpClient } from '@angular/common/http';
import { AfterContentChecked, AfterContentInit, AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslationService, I18nModule } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { pairwise } from 'rxjs/operators';
import { tap } from 'rxjs/operators';
import { ToastService } from 'src/app/core/services/toaster.service';
import { CustomProductsService } from '../custom-products/custom-products.service';
import InventoryManagementService from '../inventory-unpublished-batch/inventory-management.service';
import { Title } from '@angular/platform-browser';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { NgIf, NgFor, DecimalPipe, DatePipe } from '@angular/common';
import { ShipmentStatusDirective } from '../../../shared/components/shipment-status.directive';
@Component({
    selector: 'app-shipment-details',
    templateUrl: './shipment-details.component.html',
    styleUrls: ['./shipment-details.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, NgIf, ShipmentStatusDirective, NgFor, DecimalPipe, DatePipe, I18nModule]
})
export class ShipmentDetailsComponent implements OnInit, OnDestroy {
  Title='BHP Connect - Shipments & documents';
  navigationData: any;
  title: any;
  //pageTitle: any = 'Anchorwise LTD';
  desktopHelpDownload: any;
  mobileHelpDownload: any;
  lang = 'en';
  todayDate: any;
  shipmentStatusPercent: number = 0;
  detailsId: any;
  enableLoader: boolean = true;
  spinner: boolean = false;
  status: any;
  left = 0;
  documents:any;
  docuMents:any;
  private languageChange = new BehaviorSubject(null);
  languageChange$ = this.languageChange.asObservable();
  shipmentDetailsData: any;
  shipmentLabel:boolean = false;
  LoadPortLabelVisible: boolean;
  getLanguageChange(value): any {
    this.languageChange.next(value);
  }

  constructor(
    private router: Router,
    private inventoryManagementService: InventoryManagementService,
    private http: HttpClient,
    private customProductService: CustomProductsService,
    private translation: TranslationService,
    private inventoryService: InventoryManagementService,
    private userAccountFacade: UserAccountFacade,
    public toastService: ToastService,
    public cd: ChangeDetectorRef,
    private titleService: Title
  ) {
    const shipmentId = this.router.getCurrentNavigation()?.extras?.state;
    if (shipmentId) {
      this.detailsId = shipmentId;
    } else {
      this.detailsId = JSON.parse(localStorage.getItem('shipmentDetailsId'));
    }
   
    this.translation.translate('home.myAccount.language').subscribe(res => {
      this.lang = res;
      this.getLanguageChange(res);

      let langId;
      if (this.lang === 'en') {
        langId = 'testPDF';
      } else {
        langId = 'faqDesktopMandarin';
      }
      this.callDownloadService(langId);
    });
  }
  statusArray = {
    ArrivedAtLoadPort: null,
    BerthedAtLoadPort: null,
    VesselSailed: null,
    ArrivedAtDestination: null
  };
  ngOnDestroy(): void {
    this.customProductService.getShipmentStatusInfo(null);
    this.customProductService.isShipmentDetailPageFunction(false);
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.Title);
    //on shipment details page refresh calling the same function
    // this.customProductService.userIdChange$.pipe(pairwise()).subscribe(([previous,current])=>{
    //   if(previous!=current && current!=null && current!=undefined){
    //     this.customProductService
    //     .getShipmentDetailsData(
    //       this.detailsId.shipmentId,
    //       this.detailsId.destination,
    //       this.detailsId.loadPort,
    //       this.detailsId.loadPortCountry,
    //       this.detailsId.destinationCountry
    //     )
    //     .subscribe(data => {
    //       this.shipmentDetailsData = data;
    //       this.enableLoader = false;
    //       this.shipmentStatus();
    //       this.customProductService.getShipmentStatusInfo(this.shipmentDetailsData);
    //     });
    //   }
    // })
    //on shipment details page refresh calling the same function

    // this.customProductService.languageChange$.subscribe(data => {
    //   if(data!=null){
    //     this.customProductService.getShipmentDetailsData(this.detailsId.shipmentId,this.detailsId.destination,this.detailsId.loadPort,this.detailsId.loadPortCountry,this.detailsId.destinationCountry).subscribe(data => {
    //       this.shipmentDetailsData = data;
    //       this.enableLoader = false;
    //     this.shipmentStatus();
    //       this.customProductService.getShipmentStatusInfo(this.shipmentDetailsData);
    //             });
    //     } 
    //     });
    this.customProductService.isShipmentDetailPageFunction(true);
    this.enableLoader = true;
    this.customProductService.getHomeLinkActive(false);
    this.translation
      .translate('breadcrumb.shipmentDetails.breadcrumb')
      .subscribe(res => {
        this.navigationData = res;
      });
    this.userAccountFacade.get().subscribe((res: any) => {
      if (res) {
        //this.initialLoad();
        this.customProductService.languageChange$.subscribe(data => {
          if (data != null) {
            //this.page=0;
            //this.reachedToEnd= false;
            this.customProductService.getShipmentDetailsData(this.detailsId.shipmentId, this.detailsId.destination, this.detailsId.loadPort, this.detailsId.loadPortCountry, this.detailsId.destinationCountry).subscribe(data => {
              this.shipmentDetailsData = data;
              // Extract and deduplicate documents based on document id
              if(this.shipmentDetailsData.commodityType=='PO'){
                this.shipmentDetailsData.shipmentWithProductEntries.forEach((shipment: any) => {
          if (shipment.shipmentDocuments && Array.isArray(shipment.shipmentDocuments)) {
            const documentMap=new Map<string,any>()
            shipment.shipmentDocuments.forEach((doc: any) => {
              const documentKey = doc.documentId
              if (!documentMap.has(documentKey)) {
          documentMap.set(documentKey, doc);
              }
            });
            shipment.shipmentDocuments = Array.from( documentMap.values());
          }
        });
      }
              this.enableLoader = false;
              this.shipmentStatus();
              this.customProductService.getShipmentStatusInfo(this.shipmentDetailsData);
              if(this.shipmentDetailsData.commodityType === 'CA' || this.shipmentDetailsData.commodityType === 'NI'){
               this.LoadPortLabelVisible = false;
              }
              else{
                this.LoadPortLabelVisible = true;
              }
            }, err => {
              this.enableLoader = false;
              this.toastService.show('Error loading this page')
            }
            );
            //this.enableLoader =false;
            //this.cd.detectChanges();

          } else {
            this.enableLoader = false;
            this.toastService.show('Error loading this page')
          }
          this.inventoryService.statusBarInput$.subscribe(res => {
            this.status = res;
          });
        });

      }
    });

    //this.translation.translate('breadcrumb.shipmentDetails.pageTitle').subscribe(res => {

    //this.title = res;

    //});
    // this.userAccountFacade.get().subscribe((res: any) => {
    //  if (res) {

    //   }
    // });
    // this.customProductService
    //   .getShipmentDetailsData(
    //     this.detailsId.shipmentId,
    //     this.detailsId.destination,
    //     this.detailsId.loadPort,
    //     this.detailsId.loadPortCountry,
    //     this.detailsId.destinationCountry
    //   )
    //   .subscribe(data => {
    //     this.shipmentDetailsData = data;
    //     this.enableLoader = false;
    //     this.shipmentStatus();
    //     this.customProductService.getShipmentStatusInfo(this.shipmentDetailsData);
    //   });
    // this.inventoryService.statusBarInput$.subscribe(res => {
    //   this.status = res;
    // });
  }

  backToList(){
    let activetabSelectedbyUser = this.detailsId.activetab
    this.router.navigate([`/shipment`]);
    this.customProductService.setShipstatus(activetabSelectedbyUser);
  }
  shipmentStatus() {
    this.todayDate = new Date().getTime();
    let shipData = this.shipmentDetailsData;
   
      if(shipData?.etad && this.todayDate>=(new Date(shipData?.etad)).getTime()){
        this.shipmentStatusPercent=95;
    }
    else if(shipData?.bol && this.todayDate>=(new Date(shipData?.bol)).getTime()){
        this.shipmentStatusPercent = 75;
    }
    else if(shipData?.etd && this.todayDate>=(new Date(shipData?.etd)).getTime()){
        this.shipmentStatusPercent = 50;
    }
    else if(shipData?.etb && this.todayDate>=(new Date(shipData?.etb)).getTime()){
        this.shipmentStatusPercent = 25;
    }else{
      this.shipmentStatusPercent = 0;
    }
    // let destDate = (
    //   new Date(this.shipmentDetailsData && this.shipmentDetailsData?.etad) ||
    //   new Date()
    // ).getTime();
    // let startDate = (
    //   new Date(this.shipmentDetailsData && this.shipmentDetailsData?.eta) ||
    //   new Date()
    // ).getTime();
    // //console.log((todayDate - startDate)*100/(destDate - startDate));
    // this.shipmentStatusPercent =
    //   ((this.todayDate - startDate) * 98) / (destDate - startDate);
    // if (this.shipmentStatusPercent < 0) {
    //   this.shipmentStatusPercent = 0;
    // } else if (this.shipmentStatusPercent > 100) {
    //   this.shipmentStatusPercent = 95;
    // }
  }

  //sample downloading function
  callDownloadService(data: any) {
    this.inventoryManagementService.getFaqData(data).subscribe((resp: any) => {
      this.desktopHelpDownload = resp.desktopLink;
      this.mobileHelpDownload = resp.mobileLink;
    });
  }
  downloadDesktopPDF(docs) {
    this.spinner = true;
    this.cd.detectChanges();
    this.left = window.outerWidth/2;
    this.customProductService.getSdocsString(docs.documentId,docs.setId).subscribe(base64=>{
      if(base64.status == 'SUCCESS'){
      const ref = document.createElement("a");
      ref.href = `data:application/pdf;base64,${base64.base64Value}`
      console.log(base64)
      ref.download = `${docs.documentName}.pdf`
      ref.click()
      this.spinner = false;
      this.toastService.show('Document downloaded successfully');
      } else {
        this.spinner = false;
        this.toastService.show('Download unsuccessful, please contact support team.');
      }
    })
  }
  donwloadReport(doc) {
      this.enableLoader = true;
      this.cd.detectChanges();
      this.left = window.outerWidth / 2;
      this.customProductService.getSdocsString(doc.documentId, null, doc.nominationKey, doc.nominationKeyItem).subscribe(base64 => {
        if (base64.status == 'SUCCESS') {
            if (base64.downloadableUrl!=='NOT_FOUND') {//check whether url is there
            this.http.get(base64.downloadableUrl, { responseType: 'blob' }).subscribe((blob: Blob) => {
              const url = window.URL.createObjectURL(blob);//store the actual pdf in a browsers memory
              const ref = document.createElement("a");
              ref.href = url;
              ref.download = `${doc.documentName}.pdf`
              ref.click()
              window.URL.revokeObjectURL(url);//on click revoke the url and download it to system
              this.enableLoader = false;
              this.toastService.show('Document downloaded successfully');
            });
            } else {
            this.enableLoader = false;
            this.toastService.show('Document not available');
            }
        }
        else {
          this.enableLoader = false;
          this.toastService.show('Download unsuccessful, please contact support team.');
        }
      })

  }
  downloadPDF() {
    console.log('downloading');
  }
  downloadMobilePDF() {
    document
      .getElementById('mobileId')
      .setAttribute('href', this.mobileHelpDownload);
  }
  convertDate(dateString): any {
    if (dateString) {
      return moment
        .utc(dateString)
        .local()
        .format('DD/MM/YYYY');
    } else {
      return '--';
    }
  }
}
